import { combineReducers } from '@reduxjs/toolkit'
import maintenanceReducer from 'Features/Maintenance/maintenanceSlice'

const rootReducer = combineReducers({
  maintenance: maintenanceReducer
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
